import { createStyles, Theme } from "@material-ui/core";

export default (theme: Theme)=> createStyles({
    contentContainer: {
        width: '100%',
        paddingLeft: theme.spacing(3),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(2)
    }
});